<template>
  <div class="relative overflow-x-hidden flex-1 px-6 py-6 flex">
    <div class="flex-1">
      <!-- Title Bar -->
      <div
        class="flex items-center justify-between pb-4 border-b border-gray-300"
      >
        <div class="flex items-center space-x-6">
          <h1 class="text-2xl font-semibold text-gray-800">
            จัดการฟีเจอร์ลูกค้า
          </h1>
        </div>

        <div class="flex items-center space-x-3">
          <SearchWidgetResultsList v-model="search" />

          <AppAutoComplete
            v-model="filterStatus"
            :isLoading="loading"
            :isSearch="false"
            :options="[
              { id: 1, text: 'active', value: true },
              { id: 2, text: 'not active', value: false },
            ]"
            label="เลือกตามสถานะ"
            item-text-key="text"
            item-value-key="id"
            class="w-44 flex-shrink-0"
          />
        </div>
      </div>
      <!-- end title bar -->

      <!-- table -->
      <div class="mt-4">
        <AppDataTable
          :isCheckbox="false"
          :options="options"
          :headers="[
            {
              text: 'ชื่อฟีเจอร์',
              class: 'text-left',
              value: 'title_th',
            },
            {
              text: 'เปิด/ปิด',
              class: 'text-left w-28',
              value: 'customer_feature',
            },
            {
              text: 'จำกัดผู้ใช้ (คน)',
              class: 'text-right w-36',
              value: 'limit_max_employee',
            },
            {
              text: 'ฟรี (คน)',
              class: 'text-right w-32',
              value: 'limit_free_employee',
            },
            {
              text: 'ราคา',
              class: 'text-right w-32',
              value: 'price',
            },
            {
              text: 'เริ่มต้นใช้งาน',
              class: 'text-left w-44',
              value: 'start_time',
            },
            {
              text: 'หมดอายุ',
              class: 'text-left w-44',
              value: 'end_time',
            },
          ]"
          :items="filterCustomerFeatures.items"
          :loading="loading"
          @sort="sort"
          :isNext="true"
          :rowClassFunction="rowClassFunction"
          @rowClick="onRowClick"
        >
          <template v-slot:customer_feature="{ item }">
            <span
              v-if="item.customer_feature"
              class="
                px-2
                inline-flex
                text-xs
                leading-5
                font-semibold
                rounded-full
                bg-green-100
                text-green-800
              "
            >
              Active
            </span>
            <span
              class="
                px-2
                inline-flex
                text-xs
                leading-5
                font-semibold
                rounded-full
                bg-gray-100
                text-gray-800
              "
              v-else
              >Not Active</span
            >
          </template>
          <template v-slot:limit_max_employee="{ item }">
            <span v-if="item.customer_feature">
              {{
                item.customer_feature.limit_max_employee === 0
                  ? 'ไม่จำกัด'
                  : item.customer_feature.limit_max_employee
              }}
            </span>
            <span v-else>-</span>
          </template>
          <template v-slot:limit_free_employee="{ item }">
            {{
              item.customer_feature
                ? item.customer_feature.limit_free_employee
                : '-'
            }}
          </template>
          <template v-slot:price="{ item }">
            <span v-if="item.customer_feature">
              {{
                item.customer_feature.price_special === 0
                  ? 'ฟรี'
                  : item.customer_feature.price_special
              }}
            </span>
            <span v-else>
              {{ item.price_normal === 0 ? 'ฟรี' : item.price_normal }}
            </span>
          </template>
          <template v-slot:start_time="{ item }">
            {{
              item.customer_feature
                ? item.customer_feature.start_time
                : '' | formatDate
            }}
          </template>
          <template v-slot:end_time="{ item }">
            {{
              item.customer_feature
                ? item.customer_feature.end_time
                : '' | formatDate
            }}
          </template>
        </AppDataTable>
      </div>
      <!-- end table -->

      <!-- pagination -->
      <div class="py-4 flex items-center justify-start">
        <AppPagination
          :options="options"
          :startNumberItem="startNumberItem"
          :endNumberItem="endNumberItem"
          :totalItems="filterCustomerFeatures.total"
          :isPrevPage="isPrevPage"
          :isNextPage="isNextPage"
          @decreasePage="() => options.page--"
          @increasePage="() => options.page++"
          @itemsPerPageChange="() => (options.page = 1)"
        />
      </div>
      <!-- end pagination -->
    </div>

    <!-- form -->
    <AppSlideOverPanel :isOpen="isOpen">
      <FormCustomerFeature
        :customerFeature="customerFeature"
        :currentCustomerFeature="currentCustomerFeature"
        @onClose="onCloseForm"
        @onCancel="onCancelForm"
        @isDataChange="(value) => (isDataFormChange = value)"
      />
    </AppSlideOverPanel>
    <!-- end form -->

    <!-- confirm leave page -->
    <AppConfirmLeavePageModal
      :show="isConfirmLeavePageShow"
      :type="isConfirmLeavePageType"
      :next="isConfirmLeavePageNextFunction"
      @cancel="onCancelConfirmLeavePage"
      @submit="onSubmitConfirmLeavePage"
    >
      <template v-if="isConfirmLeavePageType === 'form'" v-slot:title
        >ต้องการปิดใช่ไหม</template
      >
      <template v-if="isConfirmLeavePageType === 'form'" v-slot:message
        >คุณยังไม่ได้บันทึกข้อมูลของคุณ
        คุณแน่ใจหรือไม่ว่าต้องการปิดโดยที่ยังไม่บันทึกข้อมูล ?</template
      >
    </AppConfirmLeavePageModal>
    <!-- end confirm leave page -->
  </div>
</template>

<script>
import moment from 'moment'

import SearchWidgetResultsList from '@/components/SearchWidgetResultsList'
import AppAutoComplete from '@/components/AppAutoComplete'
import AppDataTable from '@/components/AppDataTable'
import AppPagination from '@/components/AppPagination'
import AppSlideOverPanel from '@/components/AppSlideOverPanel'
import FormCustomerFeature from '@/components/FormCustomerFeature'
import AppConfirmLeavePageModal from '@/components/AppConfirmLeavePageModal'

export default {
  name: 'CustomerFeatureList',

  components: {
    SearchWidgetResultsList,
    AppAutoComplete,
    AppDataTable,
    AppPagination,
    AppSlideOverPanel,
    FormCustomerFeature,
    AppConfirmLeavePageModal,
  },

  data() {
    return {
      loading: false,
      search: '',
      options: {
        sortBy: 'title_th',
        sortDesc: false,
        itemsPerPage: 10,
        page: 1,
      },
      filterStatus: null,
      customerFeature: {},
      currentCustomerFeature: {},
      isOpen: false,
      timeout: null,
      isDataFormChange: false,
      isConfirmLeavePageShow: false,
      isConfirmLeavePageType: '',
      isConfirmLeavePageNextFunction: null,
    }
  },

  filters: {
    formatDate: function (value) {
      return value ? moment.utc(String(value)).format('DD/MM/YYYY HH:mm') : '-'
    },
  },

  watch: {
    search() {
      this.options.page = 1
    },

    filterStatus() {
      this.options.page = 1
    },
  },

  computed: {
    features() {
      return this.$store.state.feature.features
    },

    customerFeatures() {
      return this.$store.state.customer.customerFeatures
    },

    filterCustomerFeatures() {
      const { sortBy, sortDesc, page, itemsPerPage } = this.options

      let items = this.features.map((feature) => ({
        ...feature,
        customer_feature: this.customerFeatures.find(
          (customerFeature) =>
            customerFeature.feature.feature_uuid === feature.feature_uuid
        ),
      }))

      if (this.search) {
        items = items.filter((item) => {
          return Object.values({
            title_th: item.title_th,
            is_active: item.customer_feature ? 'active' : 'not active',
            limit_max_employee: item.customer_feature
              ? item.customer_feature.limit_max_employee === 0
                ? 'ไม่จำกัด'
                : item.customer_feature.limit_max_employee
              : '',
            limit_free_employee: item.customer_feature
              ? item.customer_feature.limit_free_employee
              : '',
            price: item.customer_feature
              ? item.customer_feature.price_special === 0
                ? 'ฟรี'
                : item.customer_feature.price_special
              : item.price_normal,
            start_time: item.customer_feature
              ? item.customer_feature.start_time
                ? moment
                    .utc(item.customer_feature.start_time)
                    .format('DD/MM/YYYY HH:mm')
                : ''
              : '',
            end_time: item.customer_feature
              ? item.customer_feature.end_time
                ? moment
                    .utc(item.customer_feature.end_time)
                    .format('DD/MM/YYYY HH:mm')
                : ''
              : '',
          }).some((s) =>
            s.toString().toLowerCase().includes(this.search.toLowerCase())
          )
        })
      }

      if (this.filterStatus) {
        items = items.filter((item) => {
          if (this.filterStatus.value) {
            return item.customer_feature
          } else {
            return item.customer_feature === undefined
          }
        })
      }

      items = items.sort((a, b) => {
        let sortA = ''
        let sortB = ''
        if (sortBy === 'start_time') {
          sortA = a.customer_feature
            ? a.customer_feature.start_time
              ? a.customer_feature.start_time
              : ''
            : ''
          sortB = b.customer_feature
            ? b.customer_feature.start_time
              ? b.customer_feature.start_time
              : ''
            : ''
        }
        if (sortBy === 'end_time') {
          sortA = a.customer_feature
            ? a.customer_feature.end_time
              ? a.customer_feature.end_time
              : ''
            : ''
          sortB = b.customer_feature
            ? b.customer_feature.end_time
              ? b.customer_feature.end_time
              : ''
            : ''
        }
        if (sortBy === 'price') {
          sortA = a.customer_feature
            ? a.customer_feature.price_special
            : a.price_normal
          sortB = b.customer_feature
            ? b.customer_feature.price_special
            : b.price_normal
        }
        if (sortBy === 'limit_free_employee') {
          sortA = a.customer_feature
            ? a.customer_feature.limit_free_employee
            : -1
          sortB = b.customer_feature
            ? b.customer_feature.limit_free_employee
            : -1
        }
        if (sortBy === 'limit_max_employee') {
          sortA = a.customer_feature
            ? a.customer_feature.limit_max_employee
            : -1
          sortB = b.customer_feature
            ? b.customer_feature.limit_max_employee
            : -1
        }
        if (sortBy === 'customer_feature') {
          sortA = a.customer_feature ? 'active' : 'not active'
          sortB = b.customer_feature ? 'active' : 'not active'
        }
        if (sortBy === 'title_th') {
          sortA = a.title_th
          sortB = b.title_th
        }

        if (sortDesc) {
          if (sortA < sortB) return 1
          if (sortA > sortB) return -1
          return 0
        } else {
          if (sortA < sortB) return -1
          if (sortA > sortB) return 1
          return 0
        }
      })

      const total = items.length

      if (itemsPerPage > 0) {
        items = items.slice((page - 1) * itemsPerPage, page * itemsPerPage)
      }

      return { items, total }
    },

    startNumberItem() {
      if (this.filterCustomerFeatures.total === 0) return 0

      return (this.options.page - 1) * this.options.itemsPerPage + 1
    },

    endNumberItem() {
      const sum = this.options.page * this.options.itemsPerPage
      if (sum < this.filterCustomerFeatures.total) return sum

      return this.filterCustomerFeatures.total
    },

    isPrevPage() {
      if (this.options.page === 1) return true

      return false
    },

    isNextPage() {
      if (this.filterCustomerFeatures.items.length === 0) return true
      if (this.filterCustomerFeatures.length === 0) return true

      return (
        this.options.page ===
        Math.ceil(this.filterCustomerFeatures.total / this.options.itemsPerPage)
      )
    },
  },

  async created() {
    this.$store.commit('setMenusCustomerActive', true)

    const uuid = this.$route.params.uuid
    const customer = await this.$store.dispatch('customer/fetchCustomer', uuid)

    this.$store.commit('setBreadcrumbs', [
      { text: 'รายชื่อลูกค้า', routeName: 'CustomerList' },
      {
        text: customer.title_th || 'ลูกค้า',
        routeName: 'CustomerDetails',
      },
      { text: 'จัดการฟีเจอร์ลูกค้า', routeName: 'CustomerFeatureList' },
    ])

    this.fetchDataFromApi()
  },

  methods: {
    onCancelConfirmLeavePage() {
      this.isConfirmLeavePageShow = false
    },

    onSubmitConfirmLeavePage(obj) {
      this.isDataFormChange = false
      if (obj.type === 'form') {
        this.isConfirmLeavePageShow = false
        this.isOpen = false
        this.currentCustomerFeature = {}
        this.customerFeature = {}
        return
      }
      if (obj.type === 'page') {
        this.isConfirmLeavePageShow = false
        this.isOpen = false
        this.currentCustomerFeature = {}
        this.customerFeature = {}
        this.timeout = setTimeout(() => {
          obj.next()
        }, 500)
        return
      }
    },

    onCancelForm() {
      this.isDataFormChange = false
      this.isOpen = false
      this.currentCustomerFeature = {}
      this.customerFeature = {}
    },

    onCloseForm() {
      if (this.isDataFormChange) {
        this.isConfirmLeavePageShow = true
        this.isConfirmLeavePageType = 'form'
        return
      }
      this.isOpen = false
      this.currentCustomerFeature = {}
      this.customerFeature = {}
    },

    rowClassFunction(item) {
      if (this.customerFeature.feature_uuid === item.feature_uuid) {
        return 'cursor-pointer bg-gray-200'
      }
      return 'cursor-pointer hover:bg-gray-100'
    },

    onRowClick(item) {
      if (this.customerFeature.feature_uuid === item.feature_uuid) {
        this.onCloseForm()
      } else {
        this.isOpen = true
        this.customerFeature = {
          ...item,
          is_active: item.customer_feature ? true : false,
          customer_feature: item.customer_feature
            ? { ...item.customer_feature }
            : {
                limit_max_employee: '',
                limit_free_employee: '',
                price_special: item.price_normal,
              },
          start_time: item.customer_feature
            ? item.customer_feature.start_time
              ? moment
                  .utc(item.customer_feature.start_time)
                  .format('DD/MM/YYYY HH:mm')
              : ''
            : '',
          end_time: item.customer_feature
            ? item.customer_feature.end_time
              ? moment
                  .utc(item.customer_feature.end_time)
                  .format('DD/MM/YYYY HH:mm')
              : ''
            : '',
        }
        this.currentCustomerFeature = {
          ...item,
          is_active: item.customer_feature ? true : false,
          customer_feature: item.customer_feature
            ? { ...item.customer_feature }
            : {
                limit_max_employee: '',
                limit_free_employee: '',
                price_special: item.price_normal,
              },
          start_time: item.customer_feature
            ? item.customer_feature.start_time
              ? moment
                  .utc(item.customer_feature.start_time)
                  .format('DD/MM/YYYY HH:mm')
              : ''
            : '',
          end_time: item.customer_feature
            ? item.customer_feature.end_time
              ? moment
                  .utc(item.customer_feature.end_time)
                  .format('DD/MM/YYYY HH:mm')
              : ''
            : '',
        }
      }
    },

    async fetchDataFromApi() {
      try {
        this.loading = true

        const uuid = this.$route.params.uuid
        await Promise.all([
          this.$store.dispatch('feature/fetchFeatures'),
          this.$store.dispatch('customer/fetchCustomerFeatures', uuid),
        ])
      } catch (error) {
        console.log(error.response)
      } finally {
        this.loading = false
      }
    },

    sort(value) {
      if (this.options.sortBy === value) {
        this.options.sortDesc = !this.options.sortDesc
        this.options.page = 1
      } else {
        this.options.sortBy = value
        this.options.sortDesc = false
        this.options.page = 1
      }
    },
  },

  beforeDestroy() {
    clearTimeout(this.timeout)
  },

  beforeRouteLeave(to, from, next) {
    if (this.isDataFormChange) {
      this.isConfirmLeavePageShow = true
      this.isConfirmLeavePageType = 'page'
      this.isConfirmLeavePageNextFunction = next
      return
    }
    if (this.isOpen) {
      this.isOpen = false
      this.timeout = setTimeout(() => {
        next()
      }, 500)
      return
    }

    next()
  },
}
</script>
